// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"86cfa8c3","418":"b746fc41","727":"af193d76"}[chunkId] + ".chunk.css";
};